// Sentry initialization should be imported first! (see Sentry docs)
import './sentry';
import { createRoot } from 'react-dom/client';
import './index.css';
import { RouterProvider } from 'react-router-dom';
import { router } from './router';
import { setScrollbarGutter } from './utils';
import './i18n';
import './dayjs';
import '@globalmed/atlas-ui/dist/enGlobalStyles.css';
import '@globalmed/atlas-ui/dist/enTheme.css';
import '@globalmed/atlas-ui/dist/atlas-ui.css';

setScrollbarGutter();

createRoot(document.getElementById('root')!).render(
  <RouterProvider router={router} />,
);
